{
  "coursesPage": {
    "delete": {
      "title": "Excluir curso",
      "description": "Tem certeza que deseja excluir este curso?",
      "confirm": "Excluir"
    },
    "toasts": {
      "archived": "Curso arquivado",
      "unarchived": "Curso desarquivado — voltou para rascunho",
      "bulkPublished_one": "{{count}} curso publicado",
      "bulkPublished_zero": "{{count}} cursos publicados",
      "bulkPublished_other": "{{count}} cursos publicados",
      "noDraftSelected": "Nenhum rascunho selecionado",
      "mergeSameTarget": "Selecione cursos diferentes do destino",
      "mergeError": "Erro ao mesclar cursos"
    },
    "header": {
      "title": "Cursos",
      "subtitle": "Gerencie seus cursos e conteúdos",
      "publishSelected": "Publicar ({{count}})",
      "mergeTooltip": "Transforma cursos selecionados em módulos de um curso existente",
      "mergeSelected": "Mesclar como Módulos ({{count}})",
      "mergeShort": "Mesclar",
      "publishAll": "Publicar Todos",
      "newCourse": "Novo Curso"
    },
    "filters": {
      "searchPlaceholder": "Buscar cursos...",
      "filter": "Filtrar",
      "all": "Todos",
      "draft": "Rascunho",
      "published": "Publicado",
      "archived": "Arquivado"
    },
    "merge": {
      "title": "Mesclar como Módulos",
      "description_one": "O curso selecionado será convertido em módulo dentro do curso destino.",
      "description_zero": "Os {{count}} cursos selecionados serão convertidos em módulos dentro do curso destino.",
      "description_other": "Os {{count}} cursos selecionados serão convertidos em módulos dentro do curso destino.",
      "targetLabel": "Curso destino",
      "targetPlaceholder": "Selecione o curso destino...",
      "targetHint": "Cada curso selecionado vira um módulo dentro do curso destino.",
      "listTitle": "Serão convertidos em módulo:",
      "cancel": "Cancelar",
      "convert": "Converter"
    },
    "grid": {
      "selectedCount_one": "{{count}} selecionado(s)",
      "selectedCount_zero": "{{count}} selecionado(s)",
      "selectedCount_other": "{{count}} selecionado(s)",
      "selectAll": "Selecionar todos",
      "pagination": "Página {{page}} de {{totalPages}} ({{total}} cursos)",
      "previous": "Anterior",
      "next": "Próxima",
      "emptyTitle": "Nenhum curso encontrado",
      "emptySearch": "Tente outra busca",
      "emptyHint": "Comece criando seu primeiro curso",
      "createCourse": "Criar Curso"
    }
  },
  "courseEdit": {
    "status": {
      "draft": "Rascunho",
      "published": "Publicado",
      "archived": "Arquivado"
    },
    "loading": "Carregando curso...",
    "notFound": "Curso não encontrado",
    "backToCourses": "Voltar para cursos",
    "breadcrumb": "Cursos",
    "appearance": "Aparência",
    "viewAsStudent": "Ver como aluno",
    "tabs": {
      "basic": "Informações",
      "content": "Conteúdo",
      "community": "Comunidade"
    },
    "basic": {
      "updated": "Curso atualizado",
      "saveError": "Erro ao salvar curso",
      "save": "Salvar Alterações"
    },
    "sectionDialog": {
      "editTitle": "Editar Seção",
      "newTitle": "Nova Seção",
      "titleLabel": "Título *",
      "titlePlaceholder": "Ex: Fundamentos do React",
      "cancel": "Cancelar",
      "save": "Salvar",
      "create": "Criar"
    },
    "linkModule": {
      "defaultTitle": "Vincular Seção Existente",
      "defaultDescription": "Selecione uma seção para vincular a este curso",
      "searchPlaceholder": "Buscar...",
      "counts": "{{lessons}} aulas · {{courses}} cursos",
      "link": "Vincular",
      "noResults": "Nenhum resultado encontrado",
      "allLinked": "Todos já estão vinculados"
    },
    "content": {
      "errors": {
        "reorderSections": "Erro ao reordenar módulos",
        "reorderChildren": "Erro ao reordenar sub-módulos",
        "deleteSection": "Erro ao excluir seção",
        "unlinkSection": "Erro ao desvincular seção",
        "saveSection": "Erro ao salvar seção",
        "linkSection": "Erro ao vincular seção",
        "linkModule": "Erro ao vincular módulo",
        "unlinkModule": "Erro ao desvincular módulo"
      },
      "deleteSection": {
        "title": "Excluir seção",
        "description": "Tem certeza que deseja excluir esta seção e todo seu conteúdo?",
        "confirm": "Excluir"
      },
      "unlinkSection": {
        "title": "Desvincular seção",
        "description": "A seção será removida deste curso mas continuará existindo. Deseja continuar?",
        "confirm": "Desvincular"
      },
      "unlinkModule": {
        "title": "Desvincular módulo",
        "description": "O módulo será removido desta seção mas continuará existindo. Deseja continuar?",
        "confirm": "Desvincular"
      },
      "sectionsCount_one": "{{count}} seção",
      "sectionsCount_zero": "{{count}} seções",
      "sectionsCount_other": "{{count}} seções",
      "lessonsCount_one": "{{count}} aula",
      "lessonsCount_zero": "{{count}} aulas",
      "lessonsCount_other": "{{count}} aulas",
      "modulesCount_one": "{{count}} módulo",
      "modulesCount_zero": "{{count}} módulos",
      "modulesCount_other": "{{count}} módulos",
      "sharedCourses_one": "{{count}} curso",
      "sharedCourses_zero": "{{count}} cursos",
      "sharedCourses_other": "{{count}} cursos",
      "newSection": "Nova Seção",
      "linkSection": "Vincular Seção",
      "loading": "Carregando...",
      "editSectionTitle": "Editar seção",
      "unlinkSectionTitle": "Desvincular seção",
      "deleteSectionTitle": "Excluir seção",
      "linkModule": "Vincular Módulo",
      "unlinkModuleTitle": "Desvincular módulo",
      "noModules": "Nenhum módulo vinculado a esta seção",
      "emptyTitle": "Nenhuma seção criada ainda",
      "emptyHint": "Crie seções para organizar o conteúdo do curso",
      "createSection": "Criar Seção",
      "linkExisting": "Vincular Existente",
      "linkModuleDialog": {
        "title": "Vincular Módulo",
        "description": "Selecione um módulo para vincular a esta seção"
      }
    },
    "community": {
      "unavailable": {
        "locked": "vitrine trancada",
        "noPosts": "não aceita posts"
      },
      "notConfigured": {
        "title": "Comunidade não configurada",
        "description": "Defina a variável <code>COMMUNITY_SSO_SECRET</code> no backend e reinicie o servidor para liberar o vínculo entre trilhas e espaços da comunidade."
      },
      "linked": "Espaço vinculado ao curso",
      "unlinked": "Vínculo com a comunidade removido",
      "saveError": "Erro ao salvar vínculo",
      "spaceLabel": "Espaço da comunidade",
      "loadingSpaces": "Carregando espaços...",
      "chooseSpace": "Escolha um espaço",
      "none": "Nenhum (sem comunidade nesta trilha)",
      "hint": "Este é o espaço padrão do curso. Cada módulo pode sobrescrever essa escolha na própria aba Comunidade — quando o módulo tem um espaço definido, ele vence sobre o do curso.",
      "noSpaces": "Nenhum espaço encontrado na comunidade. Crie um espaço por lá para poder vinculá-lo aqui.",
      "save": "Salvar Alterações"
    }
  },
  "courseForm": {
    "validation": {
      "titleMin": "Título deve ter no mínimo 3 caracteres",
      "bannerRequired": "Banner é obrigatório para cursos publicados"
    },
    "title": "Título *",
    "titlePlaceholder": "Ex: React Avançado",
    "shortDescription": "Descrição Curta",
    "shortDescriptionPlaceholder": "Uma breve descrição do curso",
    "description": "Descrição Completa",
    "descriptionPlaceholder": "Descreva o conteúdo do curso em detalhes...",
    "images": {
      "title": "Imagens do Curso",
      "subtitle": "Adicione imagens em diferentes formatos para melhor exibição na plataforma",
      "thumbnail": "Miniatura Padrão",
      "thumbnailHint": "Imagem quadrada/padrão do curso",
      "horizontal": "Miniatura Horizontal (740x415px)",
      "horizontalHint": "Usada nos banners e seções horizontais (proporção 16:9)",
      "vertical": "Miniatura Vertical",
      "verticalHint": "Visualizações mobile e grids (proporção 9:16 ou similar)",
      "banner": "Banner (1920px largura)",
      "bannerHint": "Carrossel principal em tela cheia (proporção 21:9 ou 16:9 wide)",
      "bannerRequired": "— Obrigatório para publicação"
    },
    "status": "Status *",
    "statusPlaceholder": "Selecione o status",
    "statusOptions": {
      "draft": "Rascunho",
      "published": "Publicado",
      "archived": "Arquivado"
    },
    "trail": "Trilha de Aprendizado",
    "trailHint": "Habilita a visualização em trilha para os alunos",
    "visibility": "Para quem não comprou",
    "visibilityOptions": {
      "locked": "Visível com bloqueio",
      "hidden": "Oculto"
    },
    "visibilityHints": {
      "locked": "Aparece na vitrine com cadeado e botão de compra. O botão usa a oferta Xtreed ligada a um grupo de acesso deste curso.",
      "hidden": "Só aparece para quem já tem acesso. Os demais alunos não veem o curso nem conseguem abri-lo pelo link."
    }
  },
  "courseFormDialog": {
    "saveError": "Erro ao salvar curso",
    "title": "Novo Curso",
    "description": "Preencha as informações para criar um novo curso",
    "cancel": "Cancelar",
    "submit": "Criar Curso"
  },
  "courseCard": {
    "status": {
      "draft": "Rascunho",
      "published": "Publicado",
      "archived": "Arquivado"
    },
    "selectAria": "Selecionar {{title}}",
    "students_one": "<num>{{count}}</num> aluno",
    "students_zero": "<num>{{count}}</num> alunos",
    "students_other": "<num>{{count}}</num> alunos",
    "modules_one": "{{count}} módulo",
    "modules_zero": "{{count}} módulos",
    "modules_other": "{{count}} módulos",
    "lessons_one": "{{count}} aula",
    "lessons_zero": "{{count}} aulas",
    "lessons_other": "{{count}} aulas",
    "editAria": "Editar {{title}}",
    "edit": "Editar",
    "editTooltip": "Editar curso, informações e conteúdo",
    "appearanceAria": "Editar aparência de {{title}}",
    "appearance": "Aparência",
    "appearanceTooltip": "Página do curso, seções e menu",
    "moreActionsAria": "Mais ações para {{title}}",
    "moreActions": "Mais ações",
    "viewAsStudent": "Ver como aluno",
    "publish": "Publicar",
    "archive": "Arquivar",
    "unarchive": "Desarquivar",
    "mergeAsModule": "Mesclar como Módulo",
    "delete": "Excluir"
  },
  "levelForm": {
    "validation": {
      "nameRequired": "Nome é obrigatório",
      "minPointsMin": "Pontuação mínima deve ser >= 0"
    },
    "updated": "Nível atualizado com sucesso!",
    "created": "Nível criado com sucesso!",
    "saveError": "Erro ao salvar nível",
    "editTitle": "Editar Nível",
    "createTitle": "Criar Nível",
    "description": "Configure os dados do nível",
    "name": "Nome do nível",
    "namePlaceholder": "Ex: Nível 1",
    "minPoints": "Pontuação mínima",
    "maxPoints": "Pontuação máxima",
    "optional": "Opcional",
    "color": "Cor (hex)",
    "order": "Ordem",
    "cancel": "Cancelar",
    "saving": "Salvando...",
    "save": "Salvar",
    "create": "Criar"
  },
  "categories": {
    "toasts": {
      "created": "Categoria criada com sucesso",
      "createError": "Erro ao criar categoria",
      "updated": "Categoria atualizada com sucesso",
      "updateError": "Erro ao atualizar categoria",
      "deleted": "Categoria excluída com sucesso",
      "deleteError": "Erro ao excluir categoria"
    },
    "validation": {
      "nameMin": "Nome deve ter no mínimo 2 caracteres"
    },
    "title": "Categorias",
    "subtitle": "Gerencie as categorias dos seus cursos",
    "new": "Nova Categoria",
    "emptyTitle": "Nenhuma categoria",
    "emptyHint": "Crie sua primeira categoria para organizar os cursos",
    "create": "Criar Categoria",
    "coursesCount_one": "{{count}} curso",
    "coursesCount_zero": "{{count}} cursos",
    "coursesCount_other": "{{count}} cursos",
    "dialog": {
      "editTitle": "Editar Categoria",
      "newTitle": "Nova Categoria",
      "editDescription": "Edite as informações da categoria",
      "newDescription": "Preencha as informações para criar uma nova categoria",
      "name": "Nome *",
      "namePlaceholder": "Ex: Desenvolvimento Web",
      "description": "Descrição",
      "descriptionPlaceholder": "Uma breve descrição da categoria...",
      "color": "Cor",
      "customColor": "Ou escolha uma cor personalizada",
      "cancel": "Cancelar",
      "save": "Salvar",
      "create": "Criar"
    },
    "delete": {
      "title": "Excluir categoria?",
      "description": "Tem certeza que deseja excluir a categoria <bold>{{name}}</bold>? Cursos associados ficarão sem categoria.",
      "cancel": "Cancelar",
      "confirm": "Excluir"
    }
  },
  "trailForm": {
    "validation": {
      "titleRequired": "Título é obrigatório",
      "slugRequired": "Slug é obrigatório",
      "productRequired": "Produto é obrigatório"
    },
    "basicInfo": "Informações Básicas",
    "title": "Título",
    "titlePlaceholder": "Nome da trilha",
    "slugPlaceholder": "nome-da-trilha",
    "slugHint": "URL amigável para a trilha (gerado automaticamente)",
    "description": "Descrição",
    "descriptionPlaceholder": "Descreva o que o aluno aprenderá nesta trilha",
    "thumbnail": "Imagem de Capa (URL)",
    "settings": "Configurações",
    "estimatedHours": "Tempo Estimado (horas)",
    "difficulty": "Dificuldade",
    "difficultyPlaceholder": "Selecione a dificuldade",
    "difficultyOptions": {
      "beginner": "Iniciante",
      "intermediate": "Intermediário",
      "advanced": "Avançado"
    },
    "publish": "Publicar Trilha",
    "publishHint": "Torna a trilha visível para os estudantes",
    "tags": "Tags",
    "newTag": "Nova tag",
    "steps": {
      "title": "Cursos da Trilha",
      "add": "Adicionar Curso",
      "emptyTitle": "Nenhum curso adicionado ainda.",
      "emptyHint": "Clique em \"Adicionar Curso\" para começar.",
      "course": "Curso",
      "coursePlaceholder": "Selecione um curso",
      "delay": "Delay (dias)",
      "delayHint": "Dias para liberar após step anterior",
      "required": "Obrigatório"
    },
    "cancel": "Cancelar",
    "saving": "Salvando...",
    "save": "Salvar Trilha"
  }
}
